import {Spinner} from './spinner';
import styles from './spinner.module.scss';
interface OwnProps {
    fadeIn?: boolean;
}

export function CenteredSpinner({fadeIn = true}: OwnProps) {
    return (
        <div className={`${styles.centered_spinner} ${fadeIn === true ? styles.fadeIn : ''}`}>
            <Spinner />
        </div>
    );
}
